/**
 * 优惠券抢购规则弹窗组件
 * 用于显示抢购规则内容
 */
if (!customElements.get('marketing-coupon-snap-up-rules')) {
  customElements.define(
    'marketing-coupon-snap-up-rules',
    class MarketingCouponSnapUpRules extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      /**
       * 初始化组件
       */
      init() {
        // 关闭按钮事件（关闭图标）
        const closeBtn = this.querySelector('.marketing-coupon-snap-up-rules-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.closeModal();
          });
        }

        // 点击遮罩层关闭
        this.addEventListener('click', (e) => {
          if (e.target === this) {
            this.closeModal();
          }
        });
      }

      /**
       * 显示弹窗
       */
      showModal() {
        // 显示弹窗
        this.classList.remove('hidden');
        this.classList.add('flex');
        window.litime?.disableScroll();
      }

      /**
       * 关闭弹窗
       */
      closeModal() {
        this.classList.add('hidden');
        this.classList.remove('flex');
        window.litime?.enableScroll();
      }
    }
  );
}
